// generated by srcset-codegen
import src from "./file-text.svg";

const width = 17;
const height = 16;
export default { src, width, height };
